var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPreferencesMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7207",
    "data-name": "Group 7207",
    transform: "translate(34.376 34) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(0.376)",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7020",
    "data-name": "Path 7020",
    d: "M10.991,8.855a1.474,1.474,0,0,0-1.168-.437l-6.838,0c0-2.185,0-3.293,0-6.716,0-.123,0-.247-.008-.369A1.335,1.335,0,0,0,2.055.109a1.516,1.516,0,0,0-1.618.3A1.474,1.474,0,0,0,0,1.582c0,3.47,0,4.6,0,6.839H0V11.4H0v0H9.7c.123,0,.247,0,.368-.008a1.336,1.336,0,0,0,1.228-.923,1.517,1.517,0,0,0-.3-1.618",
    transform: "translate(8.936 15.654) rotate(-45)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPreferencesMobile);
export default __webpack_public_path__ + "static/media/ico-preferences-mobile.e895450776c66ef381960fcab3a2380c.svg";
export { ForwardRef as ReactComponent };